const PLAN_ERROR_I18N_KEYS = {
    seat_limit_reached: 'seat_limit_reached',
    feature_not_in_plan: 'feature_not_in_plan',
    subscription_expired: 'subscription_expired',
    subscription_inactive: 'subscription_inactive',
};

export const PLAN_LIMIT_GENERIC_KEY = 'plan_limit_generic';

export const resolvePlanErrorI18nKey = (code) =>
    PLAN_ERROR_I18N_KEYS[code] || PLAN_LIMIT_GENERIC_KEY;
